const configCuration = {
    curation: {
        listLayout: 'CurationListDefaultLayout',
        filterLayout: 'CurationFilterDefaultLayout',
        paginationLayout: 'PaginationDefaultLayout',
        getFunc: 'getCuration',
        listApiParamSet: {
            ip: 1,
            sp: 1,
        },
        keyName: 'cu',
        pageRow: 10,
    },

}
import util from "@/mixins/util";

export default {
    methods: {
        returnCurationConfig(type) {
            return configCuration[type];
        },

    },
    filterConfig: {
        ina: {
            type: 'query',
            classname: 'searchInput',
        },
        orni: {
            type: 'query',
            classname: 'searchInput',
        },
        prni: {
            type: 'query',
            classname: 'searchInput',
        },
        cmty:{
            type: 'terms',
            classname: 'filterType',
        },
        //상태
        imst :{
            type:'match',
            classname : 'filterStatus'
        },
        ic :{
            type:'match',
            classname : 'filterCategory'
        },
        ed: {
            type: 'match',
            classname: 'filterEdition',
        },
        ty: {
            type: 'match',
            classname: 'filterType',
        },

    }
}
